import { render } from "./MenuItemNode.vue?vue&type=template&id=12af53f3&scoped=true"
import script from "./MenuItemNode.vue?vue&type=script&lang=js"
export * from "./MenuItemNode.vue?vue&type=script&lang=js"

import "./MenuItemNode.vue?vue&type=style&index=0&id=12af53f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12af53f3"]])

export default __exports__